var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC4E6256-AC08-48DC-AD4B-C3D4FDE625A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-kit-WIP",
    transform: "translate(-286.000000, -429.000000)",
    fill: "#344355",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input",
    transform: "translate(60.000000, 410.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.405144,20.5959497 L232.485239,22.677208 C232.094218,23.2734427 231.849003,23.973452 231.802393,24.7240906 C231.642835,27.2814001 233.737547,29.3857241 236.274113,29.2251201 C237.028155,29.1761054 237.731104,28.9224482 238.328058,28.5194095 L240.00887,30.1999605 C238.737662,30.720567 237.392464,31 236,31 C232.178787,31 228.713511,28.895676 226.15649,25.4735758 C225.947837,25.1935484 225.947837,24.8023336 226.15649,24.5223061 C227.383819,22.8817301 228.820395,21.5438005 230.405144,20.5959497 Z M236,19 C239.821213,19 243.286489,21.104324 245.84351,24.5264242 C246.052163,24.8064516 246.052163,25.1976664 245.84351,25.4776939 C244.658682,27.0614594 243.278847,28.3631759 241.758953,29.304183 L241.849242,29.2122195 L239.679552,27.0424493 C239.973377,26.5113394 240.156817,25.9116666 240.197607,25.2759094 C240.357165,22.7185999 238.262453,20.6142759 235.725887,20.7748799 C235.083347,20.8153019 234.478148,21.0041265 233.94406,21.3073613 L232.311847,19.6744148 C233.487839,19.2346166 234.724078,19 236,19 Z M233.917006,24.1081315 L236.899948,27.0903909 C236.666198,27.1930002 236.41254,27.2566589 236.147284,27.273164 C234.780812,27.3596431 233.651631,26.2271791 233.741639,24.8517502 C233.757673,24.5897204 233.818719,24.3392909 233.917006,24.1081315 Z M238.262453,25.1441318 C238.253253,25.2866311 238.230901,25.4256601 238.196633,25.5599986 L235.430284,22.7926064 C235.567974,22.7560642 235.710607,22.7323152 235.856807,22.7227179 C237.223279,22.6362388 238.35246,23.7687028 238.262453,25.1441318 Z",
    id: "icon-hidePassword"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHidePassword);
export default __webpack_public_path__ + "static/media/icon-hidePassword.278ba76db486a341322711f9def64aee.svg";
export { ForwardRef as ReactComponent };